var styles = {"tooltip":"styles_tooltip__7odQT","tip":"styles_tip__eEtYA","content":"styles_content__k4z5w"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
